import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { UatService } from '../uat.service';
import { MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize } from 'rxjs';
import { helper } from "../../../../../environments/helper";

@Component({
    selector: 'app-add-uat',
    templateUrl: './add-uat.component.html',
    styleUrls: ['./add-uat.component.scss']
})
export class AddUatComponent {
    // general error
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;

    form: FormGroup = new FormGroup({
        denumire_institutie: new FormControl('', [Validators.required]),
        email_institutie: new FormControl('', [Validators.email]),
        locatie: new FormControl(''),
        telefon: new FormControl(''),
    });

    constructor(
        private dialogRef: MatDialogRef<AddUatComponent>,
        private uatService: UatService,
        private notificationService: NotificationService,
        private authService: AuthService
    ) {
        this.processToken();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.uatService.setToken(token);
        });
    }

    submitForm() {
        this.isLoading = true;

        const uat = {
            denumire_institutie: this.form.get('denumire_institutie')?.value,
            email_institutie: this.form.get('email_institutie')?.value,
            locatie: this.form.get('locatie')?.value,
            telefon: this.form.get('telefon')?.value,
        };

        this.uatService
            .addUat(uat)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
